require('object-fit-polyfill');
require('respimg-polyfill');
require('bgset');
const lazysizes = require('lazysizes');
const delegate = require('delegate');
import { str2json } from '../utilities';

export default {
  init: function (app) {
    this.app = app;
    delegate(
      document.body,
      '.has-link',
      'click',
      (e) => {
        // If already a link bailout
        if (e.target.tagName == 'A' || e.target.tagName == 'BUTTON') {
          return;
        }
        const link = e.delegateTarget.querySelector('a');
        if (link && link.href) {
          e.preventDefault();
          window.location.href = link.href;
        }
      },
      false
    );
    delegate(
      document.body,
      '[data-action]',
      'click',
      (e) => {
        e.preventDefault();
        const evData = str2json(e.delegateTarget.dataset.action);
        this.app.emit(evData.type, { identifier: evData.target, action: evData.action });
      },
      false
    );

    if (!navigator.cookieEnabled) {
      document.body.classList.add('cookies-not-supported');
    }

    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
  },
};
